import Vue from 'vue';
import VueFormulate from '@braid/vue-formulate';
import FormulateVSelect from '@/views/components/formulate/FormulateVSelect.vue';
import FormulateVFile from '@/views/components/formulate/FormulateVFile.vue';

// Custom inputs are wired through Formulate's `library` so they can be used both in a `:schema`
// and as a plain `<FormulateInput type="...">`. They wrap the app's own controls (VSelect, the
// file uploader) so the look and behaviour match the rest of the interface instead of Formulate's
// stock widgets.
Vue.component('FormulateVSelect', FormulateVSelect);
Vue.component('FormulateVFile', FormulateVFile);

Vue.use(VueFormulate, {
    library: {
        vselect: { classification: 'select', component: 'FormulateVSelect' },
        vmultiselect: { classification: 'select', component: 'FormulateVSelect' },
        vfile: { classification: 'text', component: 'FormulateVFile' },
    },
    rules: {
        // Mirrors the backend's link check (App\Services\FormFieldSubmissionBuilder): only require an
        // http(s) scheme, not a full RFC URL, so internal links with Cyrillic hosts/paths are allowed.
        // An empty value is the `required` rule's business — Vue Formulate runs every rule (there is no
        // implicit skip-on-empty), so without this an OPTIONAL link left blank would block the form.
        httpurl: ({ value }) => {
            if (value === null || value === undefined || value === '') {
                return true;
            }

            return typeof value === 'string' && /^https?:\/\/\S/iu.test(value.trim());
        },
    },
    locales: {
        ru: {
            required: ({ name }) => `Поле «${name}» обязательно для заполнения`,
            number: ({ name }) => `Поле «${name}» должно быть числом`,
            httpurl: ({ name }) => `Поле «${name}» должно содержать ссылку (http/https)`,
            matches: ({ name }) => `Поле «${name}» имеет недопустимый формат`,
            max: ({ name, args }) => `Поле «${name}» длиннее ${args[0]} символов`,
            min: ({ name, args }) => `Поле «${name}» короче ${args[0]} символов`,
            default: ({ name }) => `Поле «${name}» заполнено неверно`,
        },
    },
    locale: 'ru',
});

export default VueFormulate;
